"use client";

import React from "react";
import CommonContainer from "../CommonContainer";
import { ArrowLeft } from "lucide-react";
import { useRouter } from "next-nprogress-bar";
import useStatusChallenge from "@/hooks/client/useStatusChallenge";

const MobileContainer: React.FC = () => {
  const { statusChallengeEligible, statusChallengeInProgress } =
    useStatusChallenge();
  const router = useRouter();

  return (
    <div className="relative mx-auto mt-6 flex w-full flex-col items-center bg-[#020C1B]">
      {statusChallengeEligible && !statusChallengeInProgress && (
        <>
          <div className="absolute -left-1 top-1">
            <ArrowLeft
              className="z-30 h-6 w-6 cursor-pointer text-primary"
              onClick={() => router.back()}
            />
          </div>
          <span className="w-full px-8 py-10 text-left text-3xl font-medium text-primary">
            Earn an extra{" "}
            <strong className="text-primary-gold">5% cash back</strong> for the
            next year
          </span>
          <div className="bg-global-gondola-challenge-mobile mb-20 flex h-[350px] w-full flex-col items-center justify-center px-6 lg:mb-0">
            <img
              src="/assets/gondola-challenge/challenge.png"
              alt="5%"
              className="h-[350px] w-full object-contain"
            />
            <span className="text-center text-[#B1B1B1]">
              <div className="mb-4 w-full border border-white/10" />
              The average traveler on Gondola earns{" "}
              <span className="text-primary">16%</span> of their hotel rate back
              in points
            </span>
          </div>
        </>
      )}
      <CommonContainer hideHeader />
    </div>
  );
};

export default MobileContainer;
